import { render, staticRenderFns } from "./xfooter.vue?vue&type=template&id=1812a68b&scoped=true&"
var script = {}
import style0 from "./xfooter.vue?vue&type=style&index=0&id=1812a68b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812a68b",
  null
  
)

export default component.exports